module.exports = __webpack_public_path__ + "media/newstyle/images/icon-person-grey-e1ca7a0ce4e0cce798dd720509a19346.svg";